<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 offset-sm2>
        <h4>Create a new Trial</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 offset-sm2>
        <form action="" @submit.prevent="onCreateTrial">
          <v-layout row>
            <v-flex xs12 sm10>
              <v-text-field
                name="title"
                label="Title"
                id="title"
                v-model="title"
                required>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-text-field
                name="description"
                label="Description"
                v-model="description"
                id="description"
                multi-line
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-select
                name="trialEnrollment"
                label="Add Trial Enrollments"
                :items="enrollments"
                item-value="enrollmentId"
                item-text="enrollmentName"
                v-model="trialEnrollment"
                id="trialEnrollment"
                max-height="400"
                hint="Pick your enrollments"
                persistent-hint
                required
              ></v-select>      
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-select
                name="trialLocations"
                label="Add Trial Locations"
                :items="locations"
                item-value="locationId"
                item-text="locationName"
                v-model="trialLocations"
                id="trialLocations"
                multiple
                max-height="400"
                hint="Pick your locations"
                persistent-hint
              ></v-select>      
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-select
                name="trialIndications"
                label="Add Trial Indications"
                :items="indications"
                item-value="indicationId"
                item-text="indicationName"
                v-model="trialIndications"
                id="trialIndications"
                multiple
                max-height="400"
                hint="Pick your indications"
                persistent-hint
              ></v-select>      
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-select
                name="trialCoordinators"
                label="Add Trial Coordinators"
                :items="coordinators"
                item-value="coordinatorId"
                item-text="coordinatorName"
                v-model="trialCoordinators"
                id="trialCoordinators"
                multiple
                max-height="400"
                hint="Pick your Coordinators"
                persistent-hint
              ></v-select>      
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-select
                name="trialInvestigators"
                label="Add Trial Investigators"
                :items="investigators"
                item-value="investigatorId"
                item-text="investigatorName"
                v-model="trialInvestigators"
                id="trialInvestigators"
                multiple
                max-height="400"
                hint="Pick your Investigators"
                persistent-hint
              ></v-select>      
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-text-field
                name="trialLink"
                label="Link"
                id="trialLink"
                v-model="trialLink"
                required>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm10>
              <v-btn 
              class="primary" 
              :disabled="!formIsValid"
              type="submit">
                Create Trial
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      title: '',
      description: '',
      trialEnrollment: '',
      trialLocations: [],
      trialIndications: [],
      trialInvestigators: [],
      trialCoordinators: [],
      trialLink: '',
      dialog: false
    }
  },
  props: ['id'],
  computed: {
    trial () {
      return this.$store.getters.loadedTrial(this.id)
    },
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    locations () {
      return this.$store.getters.loadedLocations
    },
    indications () {
      return this.$store.getters.loadedIndications
    },
    investigators () {
      return this.$store.getters.loadedInvestigators
    },
    coordinators () {
      return this.$store.getters.loadedCoordinators
    },
    formIsValid () {
      return this.title !== '' &&
        this.location !== '' &&
        this.description !== ''
    }
  },
  methods: {
    onCreateTrial () {
      if (!this.formIsValid) {
        return
      }
      const trialData = {
        title: this.title,
        description: this.description,
        trialEnrollment: this.trialEnrollment,
        trialLocations: this.trialLocations,
        trialIndications: this.trialIndications,
        trialInvestigators: this.trialInvestigators,
        trialCoordinators: this.trialCoordinators,
        trialLink: this.trialLink
      }
      console.log(trialData.trialIndications)
      this.$store.dispatch('createTrial', trialData)
      this.$router.push('/trials')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateTrial.vue?8495c3a6